import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './utils';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    login: build.mutation({
      query: (data) => ({
        url: 'auth/login',
        method: 'POST',
        credentials: 'include',
        body: {
          password: data.password,
          email: data.email,
        },
      }),
    }),
    googleLogin: build.mutation({
      query: (data: { token: string }) => ({
        url: 'auth/google-login',
        credentials: 'include',
        method: 'POST',
        params: data,
      }),
    }),
    recoverPassword: build.mutation({
      query: (data: { email: string }) => ({
        url: 'auth/recover-password',
        method: 'POST',
        params: data,
      }),
    }),
    setPassword: build.mutation({
      query: (data: { code: string, password: string }) => ({
        url: 'auth/set-password',
        method: 'POST',
        body: data,
      }),
    }),
    setUserProfile: build.mutation({
      query: (data) => ({
        url: 'auth/set-profile',
        method: 'PATCH',
        body: data,
      }),
    }),
    logout: build.mutation({
      query: () => ({
        url: 'auth/logout',
        method: 'POST',
        credentials: 'include',
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useGoogleLoginMutation,
  useSetUserProfileMutation,
  useLogoutMutation,
  useRecoverPasswordMutation,
  useSetPasswordMutation,
} = authApi;
